import { useCallback } from "react";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useSortedCloseStages } from "@api/organizationCloseStage.api";
import { useCreateOrganizationTaskTemplateMutation } from "@api/organizationTaskTemplate.api";
import type { TaskTypeOption } from "../OrganizationCloseTemplates/closeTemplateTasksDrawer.constants";
import {
    AddCloseTemplateTaskDrawer,
    type AddTaskResult,
} from "../OrganizationCloseTemplates/AddCloseTemplateTaskDrawer";
import { toCreateBody } from "./organizationTaskTemplateMappers";

interface Props {
    open: boolean;
    initialTaskTypeOption?: TaskTypeOption;
    onClose: () => void;
}

export const AddOrganizationTaskTemplateDrawer = ({
    open,
    initialTaskTypeOption,
    onClose,
}: Props) => {
    const sortedStages = useSortedCloseStages();
    const { toast: successToast, error: errorToast } = useToaster();
    const { mutateAsync } = useCreateOrganizationTaskTemplateMutation();

    const handleAddTask = useCallback(
        async (result: AddTaskResult) => {
            try {
                await mutateAsync(toCreateBody(result));
            } catch (error) {
                errorToast(`Failed to create task template "${result.name}"`);
                throw error;
            }
            successToast(`Created task template "${result.name}"`);
            onClose();
        },
        [mutateAsync, onClose, successToast, errorToast],
    );

    return (
        <AddCloseTemplateTaskDrawer
            open={open}
            sortedStages={sortedStages}
            initialTaskTypeOption={initialTaskTypeOption}
            onClose={onClose}
            onAddTask={handleAddTask}
            basis={null}
            submitLabel="Create"
        />
    );
};
